<template>
  <v-container class="ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0"
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          :label="target + '検索'"
          prepend-inner-icon="mdi-magnify"
          v-model="params.search"
          @change="searchClient"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-btn
          v-if="hasSet"
          @click="resetClient"
        >
        {{ target }}選択を解除
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">検索結果</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-item-length="item_total"
            :items-per-page="50"
            :loading="loading"
            :options.sync="options"
            :footer-props="footer_props"
            disable-sort
            disable-filtering
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
            @update:options="getClients"
          >
          <template v-slot:item.action="{ item }">
            <v-btn
              small
              color="default"
              @click="setClient(item)"
            >
              選択
            </v-btn>
          </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    isDeliveryAddress: {
      type: Boolean,
      default: false,
    },
    hasSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      client: null,
      headers: [
        {text: "コード", value: "cd"},
        {text: "名称", value: "name_combined"},
        {text: "住所", value: "address_combined"},
        {text: "電話番号", value: "tel"},
        {text: "操作", value: "action", width: "130px"},
      ],
      items: [],
      params: {
        search: '',
        is_stopped: 'false',
      },
      loading: false,
      item_total: 0,
      options: {},
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
    }
  },
  computed: {
    target() {
      if (this.isDeliveryAddress) {
        return '送付先';
      } else {
        return '顧客';
      }
    },
    searchUrl() {
      if (this.isDeliveryAddress) {
        return `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/`;
      } else {
        return `${process.env.VUE_APP_API_URL_BASE}/api/masters/clients/`;
      }
    },
  },
  methods: {
    setClient(item) {
      this.params.search = '';
      this.dialog = false;
      this.$emit('setClient', item);
    },
    resetClient() {
      this.params.search = '';
      this.dialog = false;
      this.$emit('setClient', {});
    },
    async searchClient() {
      console.log(this.params.search)
      if (this.params.search) {
        this.dialog = true;
        this.getClients();
      }
    },
    async getClients() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          this.searchUrl,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        // TODO エラーメッセージ
        console.log(error)
        this.loading = false;
      }
    }
  }
}
</script>